import styled from 'styled-components';
import { ExpandMore } from '@mui/icons-material';
import { Container as ContainerBoxGrid } from '../../boxGrid/styles';

const HEADER = '57px';
const PADDING_MODAL = '91px';
const TITLE_MODAL = '27px';
const TITLE_MARGIN_MODAL = '33px';
const BUTTON_BACK = '19px';

interface IContainerProps {
  $hasScroll: boolean;
}
export const ContainerForm = styled.form<IContainerProps>`
  ${ContainerBoxGrid} {
    height: ${({ $hasScroll }) =>
      $hasScroll
        ? `calc(
        100vh - ${HEADER} - ${PADDING_MODAL} - ${TITLE_MODAL} -
          ${TITLE_MARGIN_MODAL} - ${BUTTON_BACK}
      )`
        : 'auto'};
    overflow: auto;
  }
`;

export const AccordionTitle = styled.div`
  color: black;
  font-weight: bold;
`;

export const IconExpandMore = styled(ExpandMore)`
  &&& {
    color: ${({ theme }) => theme.pantone2726C};
    font-size: 30px;
  }
`;

